import React from "react";
import classNames from "classnames";
import CaButton from "../button/CaButton";
import { PlusColorIcon } from "@/icons/color-icons";

export type CaNoDataProps = {
  noText?: string;
  btnText: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};

export function CaNoData({ noText, btnText, className, disabled, onClick }: CaNoDataProps) {
  return (
    <div
      className={classNames(
        className,
        "font-sans-serif",
        "flex",
        "flex-col",
        "items-center",
        "justify-center",
      )}
    >
      {noText && <div className='font-sans-serif text-lg text-gray-800'>{noText}</div>}
      {onClick && (
        <CaButton
          disabled={disabled}
          className='mt-5'
          onClick={onClick}
          minimal
          leftIcon={<PlusColorIcon />}
        >
          {btnText}
        </CaButton>
      )}
    </div>
  );
}

export default CaNoData;
